import Web3DViewer from './components/Web3DViewer';
import ColorsWrapper from '@styles/colors';

// Web bypasses the WebView path entirely. Living in a `.web.js` sibling keeps
// the ~660 KB three.js WebView bundle out of the web Webpack chunk — Webpack's
// resolve.extensions picks this file on web, Metro skips it on native.
export default ColorsWrapper(Web3DViewer);
